import React from 'react';
import Select from 'react-select';

const field = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <Select
            value={input.value}
            onChange={input.onChange}
            onBlur={() => input.onBlur(input.value)}
            options={options}
            placeholder={placeholder}
            simpleValue
        />
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

export default field;


// WEBPACK FOOTER //
// ./components/ReduxForm/dropdown.js